import { ReactNode, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ImPhoneHangUp } from "react-icons/im";
import Button from "../Button";
import ConfirmActionDialog from "./ConfirmActionDialog";
import { useIsMobile } from "../../../hooks/layout";

export default function ConfirmLeaveDialog(props: {
  link: string;
  trigger?: ReactNode;
  onConfirm?: () => void;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();

  const isMobile = useIsMobile();

  return (
    <ConfirmActionDialog
      title={"Leave"}
      trigger={
        props.trigger ?? (
          <Button color="gray" borderColor="dark-gray" backgroundColor="black">
            <ImPhoneHangUp style={{ color: "var(--langfinity-red)" }} />
            {!isMobile && "Leave"}
          </Button>
        )
      }
      open={isOpen}
      onOpenChange={setIsOpen}
      content={<h3>Are you sure you want to leave?</h3>}
      action="Leave"
      onConfirm={() => {
        if (props.onConfirm) {
          props.onConfirm();
        }
        navigate(props.link);
      }}
    />
  );
}
